import "tslib"; // TODO: 解决引用顺序
import { createApp } from "vue";
import init from "./init";
import App from "./App.vue";
const app = createApp(App);
app.use(init);
app.mount("#app");
